const GlassesDataTs = {
    frameOnly: 'frame-only',
    frameAndMonofocal: 'frame-and-monofocal',
    frameAndMultifocal: 'frame-and-multifocal'
};
var ExtraTypes;
(function(ExtraTypes) {
    ExtraTypes['tinted-lenses-pack'] = 'tinted-lenses-pack';
    ExtraTypes['manufactured-lenses'] = 'manufactured-lenses';
    ExtraTypes['screen-protection-pack'] = 'screen-protection-pack';
    ExtraTypes['polarized-pack'] = 'polarized-pack';
    ExtraTypes['personalized-pack'] = 'personalized-pack';
    ExtraTypes['light-adaptive-pack'] = 'light-adaptive-pack';
    ExtraTypes['gradient-pack'] = 'gradient-pack';
})(ExtraTypes || (ExtraTypes = {}));

export { ExtraTypes, GlassesDataTs };
//# sourceMappingURL=types.js.map
